export const fmt = (n: number, decimals = 2) =>
  isNaN(n) || !isFinite(n) ? "—" : n.toFixed(decimals).replace(/\.?0+$/, "") || "0";

export const wireHeaders = ["AWG", "Diameter (in)", "Area (kcmil)", "Amps (Cu 75°C)", "Amps (Al 75°C)"];
export const wireRows: (string | number)[][] = [
  ["14", 0.0641, 4.11, 15, "—"],
  ["12", 0.0808, 6.53, 20, 15],
  ["10", 0.1019, 10.38, 30, 25],
  ["8", 0.1285, 16.51, 40, 35],
  ["6", 0.162, 26.24, 55, 40],
  ["4", 0.204, 41.74, 70, 55],
  ["3", 0.229, 52.62, 85, 65],
  ["2", 0.258, 66.36, 95, 75],
  ["1", 0.289, 83.69, 110, 85],
  ["1/0", 0.325, 105.6, 125, 100],
  ["2/0", 0.365, 133.1, 145, 115],
  ["3/0", 0.410, 167.8, 165, 130],
  ["4/0", 0.460, 211.6, 195, 150],
  ["250", "—", 250, 215, 170],
  ["300", "—", 300, 240, 195],
  ["350", "—", 350, 260, 210],
  ["500", "—", 500, 320, 260],
];

export const conduitHeaders = ["Trade Size", "ID (in)", "Area (in²)", "40% Fill (in²)"];
export const conduitRows: (string | number)[][] = [
  ["1/2\"", 0.622, 0.304, 0.122],
  ["3/4\"", 0.824, 0.533, 0.213],
  ["1\"", 1.049, 0.864, 0.346],
  ["1-1/4\"", 1.380, 1.496, 0.598],
  ["1-1/2\"", 1.610, 2.036, 0.814],
  ["2\"", 2.067, 3.356, 1.342],
  ["2-1/2\"", 2.469, 4.788, 1.915],
  ["3\"", 3.068, 7.393, 2.957],
  ["3-1/2\"", 3.548, 9.887, 3.955],
  ["4\"", 4.026, 12.730, 5.092],
];

export const groundData = [
  { ocpd: 15, copper: "14 AWG", aluminum: "12 AWG" },
  { ocpd: 20, copper: "12 AWG", aluminum: "10 AWG" },
  { ocpd: 30, copper: "10 AWG", aluminum: "8 AWG" },
  { ocpd: 40, copper: "10 AWG", aluminum: "8 AWG" },
  { ocpd: 60, copper: "10 AWG", aluminum: "8 AWG" },
  { ocpd: 100, copper: "8 AWG", aluminum: "6 AWG" },
  { ocpd: 200, copper: "6 AWG", aluminum: "4 AWG" },
  { ocpd: 300, copper: "4 AWG", aluminum: "2 AWG" },
  { ocpd: 400, copper: "3 AWG", aluminum: "1 AWG" },
  { ocpd: 500, copper: "2 AWG", aluminum: "1/0" },
  { ocpd: 600, copper: "1 AWG", aluminum: "2/0" },
  { ocpd: 800, copper: "1/0", aluminum: "3/0" },
  { ocpd: 1000, copper: "2/0", aluminum: "4/0" },
  { ocpd: 1200, copper: "3/0", aluminum: "250 kcmil" },
  { ocpd: 1600, copper: "4/0", aluminum: "350 kcmil" },
  { ocpd: 2000, copper: "250 kcmil", aluminum: "400 kcmil" },
  { ocpd: 2500, copper: "350 kcmil", aluminum: "600 kcmil" },
  { ocpd: 3000, copper: "400 kcmil", aluminum: "600 kcmil" },
  { ocpd: 4000, copper: "500 kcmil", aluminum: "800 kcmil" },
  { ocpd: 5000, copper: "700 kcmil", aluminum: "1200 kcmil" },
  { ocpd: 6000, copper: "800 kcmil", aluminum: "1200 kcmil" },
];

export const findEGC = (amps: number) => {
  if (amps <= 0 || isNaN(amps)) return null;
  return groundData.find((r) => r.ocpd >= amps) ?? null;
};

export const motor1phHeaders = ["HP", "115V FLA", "200V FLA", "230V FLA"];
export const motor1phRows: (string | number)[][] = [
  ["1/6", 4.4, 2.5, 2.2], ["1/4", 5.8, 3.3, 2.9], ["1/3", 7.2, 4.1, 3.6],
  ["1/2", 9.8, 5.6, 4.9], ["3/4", 13.8, 7.9, 6.9], ["1", 16, 9.2, 8],
  ["1-1/2", 20, 11.5, 10], ["2", 24, 13.8, 12], ["3", 34, 19.6, 17],
  ["5", 56, 32.2, 28], ["7-1/2", 80, 46, 40], ["10", 100, 57.5, 50],
];

export const motor3phHeaders = ["HP", "208V FLA", "230V FLA", "460V FLA", "575V FLA"];
export const motor3phRows: (string | number)[][] = [
  ["1/2", 2.4, 2.2, 1.1, 0.9], ["3/4", 3.5, 3.2, 1.6, 1.3],
  ["1", 4.6, 4.2, 2.1, 1.7], ["1-1/2", 6.6, 6, 3, 2.4],
  ["2", 7.5, 6.8, 3.4, 2.7], ["3", 10.6, 9.6, 4.8, 3.9],
  ["5", 16.7, 15.2, 7.6, 6.1], ["7-1/2", 24.2, 22, 11, 9],
  ["10", 30.8, 28, 14, 11], ["15", 46.2, 42, 21, 17],
  ["20", 59.4, 54, 27, 22], ["25", 74.8, 68, 34, 27],
  ["30", 88, 80, 40, 32], ["40", 114, 104, 52, 41],
  ["50", 143, 130, 65, 52], ["60", 169, 154, 77, 62],
  ["75", 211, 192, 96, 77], ["100", 273, 248, 124, 99],
  ["125", 343, 312, 156, 125], ["150", 396, 360, 180, 144],
  ["200", 528, 480, 240, 192],
];

export const getMotorFLA3ph = (hp: string, voltage: string): number | null => {
  const row = motor3phRows.find(r => String(r[0]) === hp);
  if (!row) return null;
  const vi = voltage === "208" ? 1 : voltage === "230" ? 2 : voltage === "460" ? 3 : 4;
  return row[vi] as number;
};

export const conductorAreas: { label: string; value: string; area: number }[] = [
  { label: "14 AWG", value: "14", area: 0.0097 },
  { label: "12 AWG", value: "12", area: 0.0133 },
  { label: "10 AWG", value: "10", area: 0.0211 },
  { label: "8 AWG", value: "8", area: 0.0366 },
  { label: "6 AWG", value: "6", area: 0.0507 },
  { label: "4 AWG", value: "4", area: 0.0824 },
  { label: "3 AWG", value: "3", area: 0.0973 },
  { label: "2 AWG", value: "2", area: 0.1158 },
  { label: "1 AWG", value: "1", area: 0.1562 },
  { label: "1/0", value: "1/0", area: 0.1855 },
  { label: "2/0", value: "2/0", area: 0.2223 },
  { label: "3/0", value: "3/0", area: 0.2679 },
  { label: "4/0", value: "4/0", area: 0.3237 },
  { label: "250 kcmil", value: "250", area: 0.3970 },
  { label: "300 kcmil", value: "300", area: 0.4608 },
  { label: "350 kcmil", value: "350", area: 0.5242 },
  { label: "500 kcmil", value: "500", area: 0.7073 },
];

export const getFillPercent = (numWires: number) => {
  if (numWires === 1) return 0.53;
  if (numWires === 2) return 0.31;
  return 0.40;
};

export interface WireEntry {
  id: string;
  size: string;
  count: number;
}

export const STD_FUSE = [1,3,6,10,15,20,25,30,35,40,45,50,60,70,80,90,100,110,125,150,175,200,225,250,300,350,400,450,500,600,700,800,1000,1200,1600,2000,2500,3000,4000,5000,6000];
export const STD_BREAKER = [15,20,25,30,35,40,45,50,60,70,80,90,100,110,125,150,175,200,225,250,300,350,400,450,500,600,700,800,1000,1200,1600,2000,2500,3000,4000,5000,6000];

export const nextStd = (amps: number, sizes: number[]) => sizes.find(s => s >= amps) ?? amps;

export const OCPD_RULES: { type: string; fuse: number; breaker: number }[] = [
  { type: "Non-Time-Delay Fuse", fuse: 3.0, breaker: 0 },
  { type: "Dual-Element (Time-Delay) Fuse", fuse: 1.75, breaker: 0 },
  { type: "Inverse-Time Breaker", fuse: 0, breaker: 2.5 },
  { type: "Instantaneous-Trip Breaker", fuse: 0, breaker: 8.0 },
];

// Wire sizing data for WireSizing calculator
export const wireSizeData = [
  { label: "14 AWG", kcmil: 4.11, cuAmps: 15, alAmps: -1, cuRes: 3.14, alRes: 5.17 },
  { label: "12 AWG", kcmil: 6.53, cuAmps: 20, alAmps: 15, cuRes: 1.98, alRes: 3.25 },
  { label: "10 AWG", kcmil: 10.38, cuAmps: 30, alAmps: 25, cuRes: 1.24, alRes: 2.04 },
  { label: "8 AWG", kcmil: 16.51, cuAmps: 40, alAmps: 35, cuRes: 0.778, alRes: 1.28 },
  { label: "6 AWG", kcmil: 26.24, cuAmps: 55, alAmps: 40, cuRes: 0.491, alRes: 0.808 },
  { label: "4 AWG", kcmil: 41.74, cuAmps: 70, alAmps: 55, cuRes: 0.308, alRes: 0.508 },
  { label: "3 AWG", kcmil: 52.62, cuAmps: 85, alAmps: 65, cuRes: 0.245, alRes: 0.403 },
  { label: "2 AWG", kcmil: 66.36, cuAmps: 95, alAmps: 75, cuRes: 0.194, alRes: 0.319 },
  { label: "1 AWG", kcmil: 83.69, cuAmps: 110, alAmps: 85, cuRes: 0.154, alRes: 0.253 },
  { label: "1/0", kcmil: 105.6, cuAmps: 125, alAmps: 100, cuRes: 0.122, alRes: 0.201 },
  { label: "2/0", kcmil: 133.1, cuAmps: 145, alAmps: 115, cuRes: 0.0967, alRes: 0.159 },
  { label: "3/0", kcmil: 167.8, cuAmps: 165, alAmps: 130, cuRes: 0.0766, alRes: 0.126 },
  { label: "4/0", kcmil: 211.6, cuAmps: 195, alAmps: 150, cuRes: 0.0608, alRes: 0.1 },
  { label: "250 kcmil", kcmil: 250, cuAmps: 215, alAmps: 170, cuRes: 0.0515, alRes: 0.0847 },
  { label: "300 kcmil", kcmil: 300, cuAmps: 240, alAmps: 195, cuRes: 0.0429, alRes: 0.0707 },
  { label: "350 kcmil", kcmil: 350, cuAmps: 260, alAmps: 210, cuRes: 0.0367, alRes: 0.0605 },
  { label: "500 kcmil", kcmil: 500, cuAmps: 320, alAmps: 260, cuRes: 0.0258, alRes: 0.0424 },
];

export const ambientTempFactors: { label: string; value: string; factor: number }[] = [
  { label: "50°F (10°C)", value: "10", factor: 1.29 },
  { label: "59°F (15°C)", value: "15", factor: 1.22 },
  { label: "68°F (20°C)", value: "20", factor: 1.15 },
  { label: "77°F (25°C)", value: "25", factor: 1.08 },
  { label: "86°F (30°C) — Standard", value: "30", factor: 1.0 },
  { label: "95°F (35°C)", value: "35", factor: 0.94 },
  { label: "104°F (40°C)", value: "40", factor: 0.88 },
  { label: "113°F (45°C)", value: "45", factor: 0.82 },
  { label: "122°F (50°C)", value: "50", factor: 0.75 },
  { label: "131°F (55°C)", value: "55", factor: 0.67 },
  { label: "140°F (60°C)", value: "60", factor: 0.58 },
];

export const conduitFillFactors: { label: string; value: string; factor: number }[] = [
  { label: "1–3 conductors", value: "3", factor: 1.0 },
  { label: "4–6 conductors", value: "6", factor: 0.8 },
  { label: "7–9 conductors", value: "9", factor: 0.7 },
  { label: "10–20 conductors", value: "20", factor: 0.5 },
  { label: "21–30 conductors", value: "30", factor: 0.45 },
  { label: "31–40 conductors", value: "40", factor: 0.4 },
  { label: "41+ conductors", value: "41", factor: 0.35 },
];

// Conduit sizes for EMT fill calc
export const conduitSizes = [
  { label: '1/2"', area: 0.304 },
  { label: '3/4"', area: 0.533 },
  { label: '1"', area: 0.864 },
  { label: '1-1/4"', area: 1.496 },
  { label: '1-1/2"', area: 2.036 },
  { label: '2"', area: 3.356 },
  { label: '2-1/2"', area: 4.788 },
  { label: '3"', area: 7.393 },
  { label: '3-1/2"', area: 9.887 },
  { label: '4"', area: 12.73 },
];

// Box fill volumes
export const BOX_FILL_VOLUMES: Record<string, number> = {
  "18": 1.50, "16": 1.75, "14": 2.00, "12": 2.25, "10": 2.50,
  "8": 3.00, "6": 5.00,
};

export const STANDARD_BOXES = [
  { label: '4" Square × 1-1/4"', volume: 18.0 },
  { label: '4" Square × 1-1/2"', volume: 21.0 },
  { label: '4" Square × 2-1/8"', volume: 30.3 },
  { label: '4-11/16" Square × 1-1/2"', volume: 29.5 },
  { label: '4-11/16" Square × 2-1/8"', volume: 42.0 },
  { label: '3" × 2" × 2" Device', volume: 10.0 },
  { label: '3" × 2" × 2-1/2" Device', volume: 12.5 },
  { label: '3" × 2" × 2-3/4" Device', volume: 14.0 },
  { label: '3" × 2" × 3-1/2" Device', volume: 18.0 },
  { label: '4" Octagon × 1-1/2"', volume: 15.5 },
  { label: '4" Octagon × 2-1/8"', volume: 21.5 },
];

// Multi-raceway types
export const RACEWAY_TYPES: { label: string; value: string; sizes: { label: string; area: number }[] }[] = [
  {
    label: "EMT", value: "emt",
    sizes: [
      { label: '1/2"', area: 0.304 }, { label: '3/4"', area: 0.533 }, { label: '1"', area: 0.864 },
      { label: '1-1/4"', area: 1.496 }, { label: '1-1/2"', area: 2.036 }, { label: '2"', area: 3.356 },
      { label: '2-1/2"', area: 4.788 }, { label: '3"', area: 7.393 }, { label: '3-1/2"', area: 9.887 },
      { label: '4"', area: 12.73 },
    ],
  },
  {
    label: "IMC", value: "imc",
    sizes: [
      { label: '1/2"', area: 0.342 }, { label: '3/4"', area: 0.586 }, { label: '1"', area: 0.959 },
      { label: '1-1/4"', area: 1.647 }, { label: '1-1/2"', area: 2.225 }, { label: '2"', area: 3.630 },
      { label: '2-1/2"', area: 5.135 }, { label: '3"', area: 7.922 }, { label: '3-1/2"', area: 10.584 },
      { label: '4"', area: 13.631 },
    ],
  },
  {
    label: "RGS (Rigid)", value: "rgs",
    sizes: [
      { label: '1/2"', area: 0.314 }, { label: '3/4"', area: 0.549 }, { label: '1"', area: 0.887 },
      { label: '1-1/4"', area: 1.526 }, { label: '1-1/2"', area: 2.071 }, { label: '2"', area: 3.408 },
      { label: '2-1/2"', area: 4.866 }, { label: '3"', area: 7.499 }, { label: '3-1/2"', area: 10.010 },
      { label: '4"', area: 12.882 },
    ],
  },
  {
    label: "PVC Sch 40", value: "pvc40",
    sizes: [
      { label: '1/2"', area: 0.285 }, { label: '3/4"', area: 0.508 }, { label: '1"', area: 0.832 },
      { label: '1-1/4"', area: 1.453 }, { label: '1-1/2"', area: 1.986 }, { label: '2"', area: 3.291 },
      { label: '2-1/2"', area: 4.695 }, { label: '3"', area: 7.268 }, { label: '3-1/2"', area: 9.737 },
      { label: '4"', area: 12.554 },
    ],
  },
  {
    label: "PVC Sch 80", value: "pvc80",
    sizes: [
      { label: '1/2"', area: 0.217 }, { label: '3/4"', area: 0.409 }, { label: '1"', area: 0.688 },
      { label: '1-1/4"', area: 1.237 }, { label: '1-1/2"', area: 1.711 }, { label: '2"', area: 2.874 },
      { label: '2-1/2"', area: 4.119 }, { label: '3"', area: 6.442 }, { label: '3-1/2"', area: 8.688 },
      { label: '4"', area: 11.258 },
    ],
  },
];

// Bend data
export const BEND_RADII: { size: string; emt: number; imc: number; rigid: number }[] = [
  { size: '1/2"',    emt: 4,    imc: 4.5,  rigid: 4.5  },
  { size: '3/4"',    emt: 5,    imc: 5.75, rigid: 5.75 },
  { size: '1"',      emt: 6,    imc: 7.25, rigid: 7.25 },
  { size: '1-1/4"',  emt: 8,    imc: 8.25, rigid: 8.25 },
  { size: '1-1/2"',  emt: 10,   imc: 9.5,  rigid: 9.5  },
  { size: '2"',      emt: 12,   imc: 10.5, rigid: 10.5 },
  { size: '2-1/2"',  emt: 15,   imc: 13,   rigid: 13   },
  { size: '3"',      emt: 18,   imc: 15,   rigid: 15   },
  { size: '3-1/2"',  emt: 21,   imc: 18,   rigid: 18   },
  { size: '4"',      emt: 24,   imc: 21,   rigid: 21   },
];

export const BENDER_SHOES: { size: string; radius: number; od: number }[] = [
  { size: '1/2" EMT',    radius: 4,  od: 0.706 },
  { size: '3/4" EMT',    radius: 5,  od: 0.922 },
  { size: '1" EMT',      radius: 6,  od: 1.163 },
  { size: '1-1/4" EMT',  radius: 8,  od: 1.510 },
];

export const BEND_MATH: { angle: number; multiplier: number; shrinkPerInch: number; takeUpPerInch: number }[] = [
  { angle: 10, multiplier: 6.0,   shrinkPerInch: 1/16,  takeUpPerInch: 0 },
  { angle: 22, multiplier: 2.6,   shrinkPerInch: 3/16,  takeUpPerInch: 0 },
  { angle: 30, multiplier: 2.0,   shrinkPerInch: 1/4,   takeUpPerInch: 0 },
  { angle: 45, multiplier: 1.414, shrinkPerInch: 3/8,   takeUpPerInch: 0 },
  { angle: 60, multiplier: 1.155, shrinkPerInch: 1/2,   takeUpPerInch: 0 },
  { angle: 90, multiplier: 1.0,   shrinkPerInch: 0,     takeUpPerInch: 1 },
];

export const TAKEUP_90: Record<string, number> = {
  '1/2"': 5,
  '3/4"': 6,
  '1"': 8,
  '1-1/4"': 11,
};

// NEMA Motor Starter Sizes
export const NEMA_STARTERS: { size: string; maxHp1ph230: number; maxHp3ph230: number; maxHp3ph460: number; maxHp3ph575: number; maxFla: number }[] = [
  { size: "00", maxHp1ph230: 1, maxHp3ph230: 1.5, maxHp3ph460: 2, maxHp3ph575: 2, maxFla: 9 },
  { size: "0", maxHp1ph230: 2, maxHp3ph230: 3, maxHp3ph460: 5, maxHp3ph575: 5, maxFla: 18 },
  { size: "1", maxHp1ph230: 3, maxHp3ph230: 7.5, maxHp3ph460: 10, maxHp3ph575: 10, maxFla: 27 },
  { size: "2", maxHp1ph230: 7.5, maxHp3ph230: 15, maxHp3ph460: 25, maxHp3ph575: 25, maxFla: 45 },
  { size: "3", maxHp1ph230: 15, maxHp3ph230: 30, maxHp3ph460: 50, maxHp3ph575: 50, maxFla: 90 },
  { size: "4", maxHp1ph230: 25, maxHp3ph230: 50, maxHp3ph460: 100, maxHp3ph575: 100, maxFla: 135 },
  { size: "5", maxHp1ph230: 50, maxHp3ph230: 100, maxHp3ph460: 200, maxHp3ph575: 200, maxFla: 270 },
  { size: "6", maxHp1ph230: 0, maxHp3ph230: 200, maxHp3ph460: 400, maxHp3ph575: 400, maxFla: 540 },
  { size: "7", maxHp1ph230: 0, maxHp3ph230: 300, maxHp3ph460: 600, maxHp3ph575: 600, maxFla: 810 },
];

// HP-rated disconnect switches
export const HP_RATED_SWITCHES: { amps: number; hp1ph240: number; hp3ph240: number; hp3ph480: number; hp3ph600: number; type: string }[] = [
  { amps: 30, hp1ph240: 3, hp3ph240: 7.5, hp3ph480: 15, hp3ph600: 20, type: "General Duty" },
  { amps: 60, hp1ph240: 7.5, hp3ph240: 15, hp3ph480: 30, hp3ph600: 40, type: "General Duty" },
  { amps: 100, hp1ph240: 15, hp3ph240: 30, hp3ph480: 60, hp3ph600: 75, type: "Heavy Duty" },
  { amps: 200, hp1ph240: 25, hp3ph240: 50, hp3ph480: 100, hp3ph600: 125, type: "Heavy Duty" },
  { amps: 400, hp1ph240: 50, hp3ph240: 100, hp3ph480: 200, hp3ph600: 250, type: "Heavy Duty" },
  { amps: 600, hp1ph240: 0, hp3ph240: 200, hp3ph480: 400, hp3ph600: 400, type: "Heavy Duty" },
  { amps: 800, hp1ph240: 0, hp3ph240: 300, hp3ph480: 500, hp3ph600: 500, type: "Heavy Duty" },
  { amps: 1200, hp1ph240: 0, hp3ph240: 0, hp3ph480: 600, hp3ph600: 600, type: "Heavy Duty" },
];

export const NEMA_ENCLOSURES = [
  { type: "1", desc: "Indoor, general purpose" },
  { type: "3R", desc: "Outdoor, rainproof" },
  { type: "4", desc: "Watertight, dust-tight" },
  { type: "4X", desc: "Corrosion-resistant, watertight" },
  { type: "12", desc: "Industrial, dust-tight, drip-tight" },
];

// Voltage drop table data
export const VD_LOADS = [15, 20, 30, 40, 50, 60, 80, 100];
export const VD_WIRE_SIZES = [
  { label: "14 AWG", cuRes: 3.14 },
  { label: "12 AWG", cuRes: 1.98 },
  { label: "10 AWG", cuRes: 1.24 },
  { label: "8 AWG", cuRes: 0.778 },
  { label: "6 AWG", cuRes: 0.491 },
  { label: "4 AWG", cuRes: 0.308 },
  { label: "3 AWG", cuRes: 0.245 },
  { label: "2 AWG", cuRes: 0.194 },
  { label: "1 AWG", cuRes: 0.154 },
  { label: "1/0", cuRes: 0.122 },
  { label: "2/0", cuRes: 0.0967 },
  { label: "3/0", cuRes: 0.0766 },
  { label: "4/0", cuRes: 0.0608 },
];

// Transformer sizes
export const XFMR_SIZES = [
  0.5, 1, 1.5, 2, 3, 5, 7.5, 10, 15, 25, 37.5, 45, 50, 75, 100, 112.5,
  150, 200, 225, 300, 500, 750, 1000, 1500, 2000, 2500,
];

// Fault current data
export const XFMR_IMPEDANCES = [
  { label: "≤25 kVA (1Φ)", value: "1.5", z: 1.5 },
  { label: "37.5–75 kVA (1Φ)", value: "2.0", z: 2.0 },
  { label: "≤75 kVA (3Φ)", value: "2.0", z: 2.0 },
  { label: "112.5–225 kVA (3Φ)", value: "3.5", z: 3.5 },
  { label: "300–500 kVA (3Φ)", value: "4.5", z: 4.5 },
  { label: "750–2500 kVA (3Φ)", value: "5.75", z: 5.75 },
  { label: "Custom", value: "custom", z: 0 },
];

export const AFC_CONDUCTORS = [
  { label: "14 AWG", z: 3.140 },
  { label: "12 AWG", z: 1.980 },
  { label: "10 AWG", z: 1.240 },
  { label: "8 AWG", z: 0.778 },
  { label: "6 AWG", z: 0.491 },
  { label: "4 AWG", z: 0.308 },
  { label: "3 AWG", z: 0.245 },
  { label: "2 AWG", z: 0.194 },
  { label: "1 AWG", z: 0.154 },
  { label: "1/0", z: 0.122 },
  { label: "2/0", z: 0.0967 },
  { label: "3/0", z: 0.0766 },
  { label: "4/0", z: 0.0608 },
  { label: "250 kcmil", z: 0.0515 },
  { label: "300 kcmil", z: 0.0429 },
  { label: "350 kcmil", z: 0.0367 },
  { label: "500 kcmil", z: 0.0258 },
];

export const AIC_RATINGS = [5000, 10000, 14000, 18000, 22000, 25000, 35000, 42000, 50000, 65000, 100000, 200000];

// Panel schedule load types
export interface LoadEntry {
  id: string;
  description: string;
  va: string;
  type: string;
}

export const LOAD_TYPES = [
  { value: "general", label: "General Lighting", demandNote: "NEC 220.42 demand factors apply" },
  { value: "small_appliance", label: "Small Appliance (1500VA ea)", demandNote: "NEC 220.52(A) — min 2 circuits × 1500VA" },
  { value: "laundry", label: "Laundry (1500VA)", demandNote: "NEC 220.52(B) — 1 circuit × 1500VA" },
  { value: "fixed_appliance", label: "Fixed Appliance", demandNote: "NEC 220.53 — 4+ appliances at 75%" },
  { value: "range", label: "Range/Oven", demandNote: "NEC 220.55 Table — Column C demand" },
  { value: "dryer", label: "Dryer", demandNote: "NEC 220.54 — min 5000VA or nameplate" },
  { value: "hvac", label: "HVAC / Heat", demandNote: "NEC 220.60 — use larger of heat or cool" },
  { value: "motor", label: "Motor", demandNote: "NEC 430.24 — largest at 125%" },
  { value: "other", label: "Other (100%)", demandNote: "No demand factor applied" },
];

// VFD data
export const VFD_DATA: { hp: string; kva460: number; inputA460: number; outputA460: number; kva230: number; inputA230: number; outputA230: number }[] = [
  { hp: "1", kva460: 1.5, inputA460: 2.5, outputA460: 2.1, kva230: 1.5, inputA230: 4.8, outputA230: 3.7 },
  { hp: "2", kva460: 2.5, inputA460: 4.2, outputA460: 3.4, kva230: 2.5, inputA230: 7.6, outputA230: 6.8 },
  { hp: "3", kva460: 3.5, inputA460: 5.6, outputA460: 4.8, kva230: 3.5, inputA230: 11.2, outputA230: 9.6 },
  { hp: "5", kva460: 5.5, inputA460: 8.8, outputA460: 7.6, kva230: 5.5, inputA230: 17.5, outputA230: 15.2 },
  { hp: "7-1/2", kva460: 8, inputA460: 12.7, outputA460: 11, kva230: 8, inputA230: 25.3, outputA230: 22 },
  { hp: "10", kva460: 11, inputA460: 16.2, outputA460: 14, kva230: 11, inputA230: 32.4, outputA230: 28 },
  { hp: "15", kva460: 16, inputA460: 24.2, outputA460: 21, kva230: 16, inputA230: 48.3, outputA230: 42 },
  { hp: "20", kva460: 20, inputA460: 31.2, outputA460: 27, kva230: 20, inputA230: 62, outputA230: 54 },
  { hp: "25", kva460: 25, inputA460: 39.2, outputA460: 34, kva230: 25, inputA230: 78.4, outputA230: 68 },
  { hp: "30", kva460: 30, inputA460: 46.2, outputA460: 40, kva230: 30, inputA230: 92, outputA230: 80 },
  { hp: "40", kva460: 40, inputA460: 60, outputA460: 52, kva230: 40, inputA230: 120, outputA230: 104 },
  { hp: "50", kva460: 50, inputA460: 75, outputA460: 65, kva230: 50, inputA230: 150, outputA230: 130 },
  { hp: "60", kva460: 60, inputA460: 89, outputA460: 77, kva230: 60, inputA230: 178, outputA230: 154 },
  { hp: "75", kva460: 75, inputA460: 111, outputA460: 96, kva230: 75, inputA230: 222, outputA230: 192 },
  { hp: "100", kva460: 100, inputA460: 144, outputA460: 124, kva230: 100, inputA230: 288, outputA230: 248 },
  { hp: "125", kva460: 125, inputA460: 180, outputA460: 156, kva230: 125, inputA230: 360, outputA230: 312 },
  { hp: "150", kva460: 150, inputA460: 208, outputA460: 180, kva230: 150, inputA230: 416, outputA230: 360 },
  { hp: "200", kva460: 200, inputA460: 277, outputA460: 240, kva230: 200, inputA230: 554, outputA230: 480 },
];

export const REACTOR_RECS = [
  { condition: "Short circuit > 100kA at VFD", pct: "5%", note: "Heavy-duty line reactor required" },
  { condition: "Utility or transformer < 10× VFD kVA", pct: "3–5%", note: "Reduces harmonic distortion & inrush" },
  { condition: "Long cable run (> 100 ft) to motor", pct: "—", note: "Output reactor or dV/dt filter recommended" },
  { condition: "Multiple VFDs on common bus", pct: "3%", note: "Minimum per VFD to limit harmonics" },
];

export const BYPASS_CONTACTORS: { size: string; maxHp460: number; maxHp230: number; maxA: number }[] = [
  { size: "1", maxHp460: 10, maxHp230: 7.5, maxA: 27 },
  { size: "2", maxHp460: 25, maxHp230: 15, maxA: 45 },
  { size: "3", maxHp460: 50, maxHp230: 30, maxA: 90 },
  { size: "4", maxHp460: 100, maxHp230: 50, maxA: 135 },
  { size: "5", maxHp460: 200, maxHp230: 100, maxA: 270 },
  { size: "6", maxHp460: 400, maxHp230: 200, maxA: 540 },
];

// Motor feeder data
export const HP_OPTIONS_3PH = ["1/2","3/4","1","1-1/2","2","3","5","7-1/2","10","15","20","25","30","40","50","60","75","100","125","150","200"];
export const VOLTAGE_OPTIONS_3PH = ["208","230","460","575"];

export interface FeederMotor {
  id: number;
  hp: string;
  voltage: string;
}

// Power factor correction
export const STD_CAPACITOR_SIZES = [5, 7.5, 10, 15, 20, 25, 30, 40, 50, 60, 75, 100, 125, 150, 200, 250, 300, 400, 500, 600, 750, 1000];
export const nextStdCap = (kvar: number) => STD_CAPACITOR_SIZES.find(s => s >= kvar) ?? kvar;

export const calcKVARMultiplier = (pfFrom: number, pfTo: number): number => {
  if (pfFrom >= pfTo || pfFrom <= 0 || pfTo <= 0 || pfFrom > 1 || pfTo > 1) return 0;
  return Math.tan(Math.acos(pfFrom)) - Math.tan(Math.acos(pfTo));
};

export const NEC_460_RULES = [
  { rule: "460.8(A)", text: "Capacitor conductors ≥ 135% of rated capacitor current" },
  { rule: "460.8(C)", text: "OCPD ≤ 250% of rated capacitor current (for individual)" },
  { rule: "460.8(C)(2)", text: "Group OCPD per standard circuit protection" },
  { rule: "460.10", text: "Discharge resistors required — reduce to ≤ 50V within 1 min (600V) or 5 min (> 600V)" },
  { rule: "460.24", text: "Capacitors on motor circuits: switch must open all ungrounded conductors simultaneously" },
  { rule: "460.28(A)", text: "Motor capacitor ≤ motor no-load magnetizing kVAR to avoid self-excitation" },
];

export const PF_PENALTY_THRESHOLDS = [
  { pf: 0.85, note: "Most utilities begin penalty charges below this PF" },
  { pf: 0.90, note: "Common target for industrial facilities" },
  { pf: 0.95, note: "Optimal — near unity, avoids over-correction" },
  { pf: 1.00, note: "Unity PF — risk of leading PF if load varies" },
];

// Panel schedule demand factor functions
export const applyLightingDemand = (totalVA: number): number => {
  if (totalVA <= 0) return 0;
  if (totalVA <= 3000) return totalVA;
  if (totalVA <= 120000) return 3000 + (totalVA - 3000) * 0.35;
  return 3000 + (120000 - 3000) * 0.35 + (totalVA - 120000) * 0.25;
};

export const applyFixedApplianceDemand = (totalVA: number, count: number): number => {
  if (count >= 4) return totalVA * 0.75;
  return totalVA;
};

export const applyRangeDemand = (totalVA: number, count: number): number => {
  if (count === 0) return 0;
  const COL_C = [0, 8000, 11000, 14000, 17000, 20000, 21000, 22000, 23000, 24000, 25000, 26000, 27000];
  if (count <= 12) return COL_C[count] ?? 8000 + (count - 1) * 1000;
  return 27000 + (count - 12) * 1000;
};

export const applyDryerDemand = (totalVA: number, count: number): number => {
  if (count === 0) return 0;
  const perUnit = Math.max(totalVA / count, 5000);
  if (count <= 4) return perUnit * count;
  const factors = [0, 1, 1, 1, 1, 0.8, 0.7, 0.65, 0.6, 0.55, 0.5];
  const factor = factors[Math.min(count, 10)] ?? 0.5;
  return perUnit * count * factor;
};

// Service entrance conductor sizing per NEC 310.12
export const SERVICE_CONDUCTORS: { amps: number; cuSize: string; alSize: string }[] = [
  { amps: 100, cuSize: "4 AWG", alSize: "2 AWG" },
  { amps: 110, cuSize: "3 AWG", alSize: "1 AWG" },
  { amps: 125, cuSize: "2 AWG", alSize: "1/0" },
  { amps: 150, cuSize: "1 AWG", alSize: "2/0" },
  { amps: 175, cuSize: "1/0", alSize: "3/0" },
  { amps: 200, cuSize: "2/0", alSize: "4/0" },
  { amps: 225, cuSize: "3/0", alSize: "250 kcmil" },
  { amps: 250, cuSize: "4/0", alSize: "300 kcmil" },
  { amps: 300, cuSize: "250 kcmil", alSize: "350 kcmil" },
  { amps: 350, cuSize: "350 kcmil", alSize: "500 kcmil" },
  { amps: 400, cuSize: "400 kcmil", alSize: "600 kcmil" },
  { amps: 500, cuSize: "500 kcmil", alSize: "750 kcmil" },
  { amps: 600, cuSize: "600 kcmil", alSize: "1000 kcmil" },
  { amps: 800, cuSize: "2× 3/0", alSize: "2× 250 kcmil" },
  { amps: 1000, cuSize: "2× 250 kcmil", alSize: "2× 400 kcmil" },
  { amps: 1200, cuSize: "2× 350 kcmil", alSize: "2× 500 kcmil" },
  { amps: 1600, cuSize: "2× 500 kcmil", alSize: "2× 750 kcmil" },
  { amps: 2000, cuSize: "3× 500 kcmil", alSize: "3× 750 kcmil" },
];

export const findServiceConductor = (amps: number) =>
  SERVICE_CONDUCTORS.find(c => c.amps >= amps) ?? null;

// Grounding electrode conductor per NEC 250.66
export const GEC_TABLE: { maxServiceCu: string; maxServiceAl: string; gecCu: string; gecAl: string }[] = [
  { maxServiceCu: "2 AWG", maxServiceAl: "1/0", gecCu: "8 AWG", gecAl: "6 AWG" },
  { maxServiceCu: "1/0", maxServiceAl: "3/0", gecCu: "6 AWG", gecAl: "4 AWG" },
  { maxServiceCu: "3/0", maxServiceAl: "250 kcmil", gecCu: "4 AWG", gecAl: "2 AWG" },
  { maxServiceCu: "Over 3/0 to 350 kcmil", maxServiceAl: "Over 250 to 500 kcmil", gecCu: "2 AWG", gecAl: "1/0" },
  { maxServiceCu: "Over 350 to 600 kcmil", maxServiceAl: "Over 500 to 900 kcmil", gecCu: "1/0", gecAl: "3/0" },
  { maxServiceCu: "Over 600 to 1100 kcmil", maxServiceAl: "Over 900 to 1750 kcmil", gecCu: "2/0", gecAl: "4/0" },
];

// Standard demand factor table for quick NEC 220 calcs
export const DEMAND_FACTOR_RANGES = [
  { label: "Lighting (first 3,000 VA)", factor: 100, necRef: "220.42" },
  { label: "Lighting (3,001–120,000 VA)", factor: 35, necRef: "220.42" },
  { label: "Lighting (over 120,000 VA)", factor: 25, necRef: "220.42" },
  { label: "Small Appliance Circuits", factor: 100, necRef: "220.52(A)" },
  { label: "Laundry Circuit", factor: 100, necRef: "220.52(B)" },
  { label: "Fixed Appliances (4+)", factor: 75, necRef: "220.53" },
  { label: "Ranges — 1 unit (Col C)", factor: 66.7, necRef: "220.55" },
  { label: "Dryers — 1 unit", factor: 100, necRef: "220.54" },
  { label: "HVAC (largest of heat/cool)", factor: 100, necRef: "220.60" },
  { label: "Motors (125% of largest)", factor: 125, necRef: "430.24" },
];

export const STD_SERVICE_SIZES = [60, 100, 125, 150, 200, 225, 320, 400, 600, 800, 1000, 1200, 1600, 2000, 2500, 3000, 4000];
export const nextStdService = (amps: number) => STD_SERVICE_SIZES.find(s => s >= amps) ?? amps;

// Category definitions for organized navigation
export const ELECTRICAL_CATEGORIES = [
  {
    id: "conductors",
    label: "Conductors",
    color: "bg-primary",
    tools: [
      { value: "wire", label: "Wire" },
      { value: "sizing", label: "Sizing" },
      { value: "ground", label: "Ground" },
      { value: "vdtable", label: "VD Table" },
      { value: "vdcalc", label: "VD Calc" },
    ],
  },
  {
    id: "raceway",
    label: "Raceway",
    color: "bg-copper",
    tools: [
      { value: "conduit", label: "Conduit" },
      { value: "fill", label: "Fill" },
      { value: "raceway", label: "Multi-Fill" },
      { value: "boxfill", label: "Box Fill" },
      { value: "bending", label: "Bending" },
      { value: "bendradius", label: "Bend Rad" },
    ],
  },
  {
    id: "motor",
    label: "Motor",
    color: "bg-safety",
    tools: [
      { value: "motor", label: "FLA" },
      { value: "starter", label: "Starter" },
      { value: "disco", label: "Disconnect" },
      { value: "feeder", label: "Feeder" },
      { value: "vfd", label: "VFD" },
    ],
  },
  {
    id: "equipment",
    label: "Equipment",
    color: "bg-conduit",
    tools: [
      { value: "xfmr", label: "Xfmr" },
      { value: "panel", label: "Panel" },
      { value: "fault", label: "Fault" },
      { value: "pfc", label: "PF" },
      { value: "demand", label: "Demand" },
      { value: "service", label: "Service" },
      { value: "lighting", label: "Lighting" },
    ],
  },
];
